import { ListItem } from "@next-platform/client-common-spicy-ui";
import React, { useCallback, useMemo } from "react";

import type { EntryCardProps } from "./types";

const SUB_LABEL_MAX_LINES = 2;
const EMPTY_KEYWORDS: string[] = [];

function EntryCard({ entry, onPress, "data-testid": testId = "EntriesList-EntryCard" }: EntryCardProps) {
  const keywords = entry?.keywords ?? EMPTY_KEYWORDS;

  const handleClick = useCallback(() => {
    onPress?.(entry);
  }, [entry, onPress]);

  const subLabel = useMemo(() => entry?.content ?? "", [entry?.content]);

  return (
    <ListItem
      className="min-h-auto"
      label={entry?.name}
      tags={keywords}
      subLabel={subLabel}
      subLabelMaxLines={SUB_LABEL_MAX_LINES}
      showSubLabelTooltip={false}
      onClick={handleClick}
      data-testid={testId}
    />
  );
}

export default React.memo(EntryCard);
